var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pAnalysisLevel)?_c('span',{class:_vm.pacingClass},[_vm._v(" "+_vm._s(_vm._f("i18nText")('dictionary.media.insertion.kpi.analysis.level.' + _vm.pAnalysisLevel,_vm.pDictionary))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }